import type { ReactElement } from 'react'
import { AddUserPage } from '@components'
import { createFileRoute } from '@tanstack/react-router'

function Add(): ReactElement {
  return <AddUserPage />
}

export const Route = createFileRoute('/settings/company_/user_/add/')({
  component: Add,
})
